import PropTypes from 'prop-types'
import React, { useState, useContext } from 'react'

import { Dimensions, Platform, TouchableOpacity, View, useWindowDimensions } from 'react-native'

import moment from 'moment'

import WebView from 'react-native-webview'

import { CollapsibleCard } from '@vfgroup-oneplatform/framework/CommonUI'
import {
  Images,
  useTheme
} from '@vfgroup-oneplatform/foundation/Components/Themes'
import {
  Icon,
  VFText,
  VFButton,
  QuickActionMenu
} from '@vfgroup-oneplatform/foundation/Components'

import UnlimitedContext from '../../Context'

import Loading from '../Loading'
import MembersList from '../MembersList'
import CustomButton from '../CustomButton'

import { INSTALL, MODEM } from '../../Utils/payment'

import { getSelectedBundleData } from '../../Utils/bundle'

import Offer from '../Offer'

import UhImages from '../../Themes/Images'

import styles from './SummaryStep.Styles'
import ReactNativeModal from 'react-native-modal'

const RowEntry = ({ label, value, valueVars, labelVars, boldLabel }) => {
  return (
    <View style={styles.flexWrapBetween}>
      <VFText
        i18nKey={label}
        placeHolders={labelVars}
        style={[styles.label, boldLabel ? styles.bold : {}]}
      />
      <VFText
        i18nKey={value}
        placeHolders={valueVars}
        style={[styles.label, styles.bold]}
      />
    </View>
  )
}

const defaults = {
  error: '',
  isError: false,
  isSuccess: false,
  isLoading: false
}

const getTime = time => {
  switch (time) {
    case '9am - 12pm':
      return { h: 10, m: 30, s: 0 }
    case '12pm - 3pm':
      return { h: 13, m: 30, s: 0 }
    case '3pm - 5pm':
      return { h: 16, m: 0, s: 0 }
  }
}

const getDate = date => {
  const [year, month, day] = (date ?? '').split('-')
  return { y: year, m: month, d: day }
}

const getInstallDates = (date, time) => {
  const { y, m, d } = getDate(date)
  const { h, m: min, s } = getTime(time)
  const installDate = new Date(y, m, d, h, min, s)
  if (moment.isDate(installDate)) {
    return installDate.toISOString()
  } else {
    return new Date().toISOString()
  }
}

const SummaryStep = ({ onCheckout, onClose }) => {
  const {
    data: {
      groupData,
      customTVs,
      bundleType,
      atlBundles,
      pegaBundles,
      customPlans,
      customSlots,
      customSpeeds,
      selectedBundle,
      installationData,
      customBundlePrice,
      customBundleOptions,
      customerData: { fixId },
      locationData: { city, street }
    }
  } = useContext(UnlimitedContext)

  const [checkoutState, setCheckoutState] = useState({
    error: '',
    isError: false,
    isSuccess: false,
    isLoading: false
  })

  const bundleData = getSelectedBundleData({
    customTVs,
    bundleType,
    atlBundles,
    pegaBundles,
    customPlans,
    customSlots,
    customSpeeds,
    selectedBundle,
    customBundlePrice,
    customBundleOptions
  })

  const handleCheckout = () => {
    onCheckout({
      body: {
        bundleType,
        groupName: groupData.name,
        installDate: getInstallDates(
          installationData.date,
          installationData.time
        ),
        price: bundleData?.price,
        address: `${street ? `${street},` : ''} ${city}, Albania`,
        plan: {
          ...(bundleData?.tariffPlan ?? {}),
          duration: bundleData?.productTerms
        },
        internet: {
          fixId: fixId ?? '',
          id: bundleData?.internet?.id,
          name: bundleData?.internet?.value,
          speed: bundleData?.download?.value
        },
        tv: bundleData?.tv,
        members: {
          id: bundleData?.slots?.id,
          name: bundleData?.slots?.value,
          entries: groupData.members.map(member => member.number)
        }
      },
      onStart: () => setCheckoutState({ ...defaults, isLoading: true }),
      onSuccess: () => {
        setCheckoutState({ ...defaults, isSuccess: true })
      },
      onError: error => {
        setCheckoutState({ ...defaults, isError: true, error: error })
      }
    })
  }

  const resetState = () => setCheckoutState(defaults)

  return (
    <View style={styles.summaryStep}>
      <View style={styles.paddingHorizontal}>
        <SelectedOfferSummary
          offer={bundleData}
          address={`${street}, ${city}`}
        />
        <MembersSummary />
        {/* <PaymentAndDelivery /> */}
      </View>
      <CostSection
        offer={bundleData}
        onCheckout={handleCheckout}
        isCheckingOut={checkoutState.isLoading}
      />
      <CheckoutSuccess
        show={checkoutState.isSuccess}
        onReset={() => {
          resetState()
          onClose()
        }}
      />
      <CheckoutError
        onReset={resetState}
        error={checkoutState.error}
        show={checkoutState.isError}
      />
    </View>
  )
}

const SelectedOfferSummary = ({ offer, address }) => {
  const theme = useTheme()

  const INSTALL_ADDRESS =
    address.replace(/\s/g, '') === ','
      ? 'Rruga Muhamet Gjollesha, Tirane, Shqiperi'
      : address

  return (
    <View style={styles.pb(8)}>
      <VFText
        style={styles.header}
        i18nKey="unlimited_summary_selection_title"
      />
      <VFText
        i18nKey="%1$s"
        placeHolders={[INSTALL_ADDRESS]}
        style={styles.description(theme)}
      />
      <Offer
        viewOnly
        type="bundle"
        offer={offer}
        stylesArray={[styles.card(theme)]}
      />
    </View>
  )
}

const MembersSummary = () => {
  const theme = useTheme()
  const {
    data: {
      groupData: { members },
      loggedInNumber
    }
  } = useContext(UnlimitedContext)
  return (
    <View style={styles.pb(8)}>
      <VFText style={styles.header} i18nKey="unlimited_my_members" />
      <VFText
        style={styles.description(theme)}
        i18nKey="unlimited_summary_members_description"
      />
      <MembersList viewOnly members={members} loggedInNumber={loggedInNumber} />
    </View>
  )
}

// <View style={[styles.flexWrapBetween, styles.pb(4)]}>
// {/* Upfront */}
// <View style={styles.totalEntry}>
//   <VFText
//     style={styles.monthly}
//     i18nKey="unlimited_summary_amount"
//     placeHolders={[UPFRONT_VALUE]}
//   />
//   <VFText
//     i18nKey="unlimited_summary_upfront"
//     style={[styles.label, styles.pb(0.5)]}
//   />
// </View>
// {/* Monthly */}
// <View style={styles.totalEntry}>
//   <VFText
//     style={styles.upfront}
//     i18nKey="unlimited_summary_amount"
//     placeHolders={[offer.price.value.toString()]}
//   />
//   <VFText
//     i18nKey="unlimited_summary_monthly"
//     style={[styles.label, styles.pb(0.5)]}
//   />
// </View>
// </View>

const CostSection = ({ offer, onCheckout, isCheckingOut }) => {
  const theme = useTheme()

  const data = [
    {
      text: 'unlimited_summary_cost_start',
      value: moment(new Date()).format('DD MMMM YYYY'),
      valueVars: []
    },
    {
      text: 'unlimited_summary_cost_duration',
      value: 'unlimited_summary_duration',
      valueVars: [offer.productTerms?.amount ?? '24']
    },
    {
      text: 'unlimited_summary_cost_cancel_period',
      value: 'unlimited_cancel_duration'
    }
  ]

  const UPFRONT_VALUE = (
    parseFloat(offer.price.value) + parseFloat(INSTALL.value)
  ).toString()

  return (
    <View style={[styles.bgWhite(theme), styles.costSection]}>
      <View style={styles.paddingHorizontal}>
        <VFText i18nKey="unlimited_my_offer" style={styles.header} />
        <VFText
          i18nKey="unlimited_summary_cost_subtitle"
          style={[styles.label, styles.pb(4)]}
        />
        <BreakLine />
        <View style={styles.pb(4)}>
          {data.map(datum => (
            <View style={styles.pb(3)}>
              <RowEntry
                label={datum.text}
                value={datum.value}
                valueVars={datum.valueVars}
              />
            </View>
          ))}
        </View>
        <BreakLine />
        <View style={styles.pb(3)}>
          <RowEntry
            value="unlimited_summary_amount"
            label="unlimited_summary_plan_monthly"
            valueVars={[offer.price.value.toString()]}
          />
        </View>
        <View style={[styles.flexWrapBetween, styles.pb(6)]}>
          <View style={styles.grow}>
            <RowEntry
              value="unlimited_summary_amount"
              label="unlimited_summary_plan_firstBill"
              valueVars={[UPFRONT_VALUE]}
            />
          </View>
          <ExplainButton offer={offer} />
        </View>
        <BreakLine />
      </View>
      {/* <Breakdown offer={offer} /> */}
      <View style={styles.paddingHorizontal}>
        <TermsAndConditions />
        <CustomButton
          onPress={onCheckout}
          isLoading={isCheckingOut}
          title="unlimited_summary_confirm_button"
          loadingTitle="unlimited_processing"
        />
      </View>
    </View>
  )
}

const Breakdown = ({ offer }) => {
  const [height, setHeight] = useState(70)
  const theme = useTheme()
  const handleHeightChange = event => {
    const { height: h } = event.nativeEvent.layout
    setHeight(h)
  }

  return (
    <View style={styles.pb(8)}>
      <CollapsibleCard
        id={1}
        openId={1}
        key={height}
        cardHeight={height}
        cardStyle={styles.breakdown(theme)}
        renderCard={() => <BreakdownHeader onLayout={handleHeightChange} />}
        renderCollapseCard={() => <BreakdownContent offer={offer} />}
      />
    </View>
  )
}

const BreakdownHeader = ({ onLayout }) => {
  return (
    <View style={styles.paddingHorizontal} onLayout={onLayout}>
      <View style={[styles.flexWrapBetween, styles.pb(4)]}>
        <VFText i18nKey="unlimited_summary_breakdown" style={styles.label} />
        <Icon type="image" name={Images.ic_chevron_down_red} size={24} />
      </View>
      <BreakLine />
    </View>
  )
}

const BreakdownContent = ({ offer }) => {
  const theme = useTheme()

  const data = [
    {
      label: 'unlimited_summary_monthly',
      value: 'unlimited_summary_amount',
      valueVars: [offer.price.value.toString()]
    },
    // {
    //   label: 'unlimited_summary_discount',
    //   value: 'unlimited_summary_amount',
    //   valueVars: [(offer.discount?.value ?? 0).toString()]
    // },
    {
      label: 'unlimited_summary_modem_deposit',
      value: 'unlimited_summary_amount',
      valueVars: [MODEM.value]
    },
    {
      label: 'unlimited_summary_installation_fee',
      value: 'unlimited_summary_amount',
      valueVars: [INSTALL.value]
    }
  ]

  // const UPFRONT_VALUE = (
  //   parseFloat(offer.price.value) + parseFloat(INSTALL.value)
  // ).toString()

  // const recapData = [
  //   {
  //     value: 'unlimited_summary_amount',
  //     label: 'unlimited_summary_first_bill',
  //     valueVars: [UPFRONT_VALUE]
  //   },
  //   {
  //     value: 'unlimited_summary_amount',
  //     label: 'unlimited_summary_recurring',
  //     labelVars: [offer.productTerms.amount],
  //     valueVars: [offer.price.value.toString()]
  //   }
  // ]

  return (
    <View>
      <View style={styles.breakdownContent(theme)}>
        <VFText
          i18nKey="unlimited_my_offer"
          style={[styles.pb(4), styles.label, styles.bold]}
        />
        {data.map(datum => (
          <View style={styles.pb(3)}>
            <RowEntry
              label={datum.label}
              value={datum.value}
              valueVars={datum.valueVars}
            />
          </View>
        ))}
      </View>
      {/* <View style={[styles.pb(8), styles.paddingHorizontal]}>
        <VFText
          i18nKey="unlimited_summary_total_to_pay"
          style={styles.totalToPay}
        />
        {recapData.map(voice => (
          <View style={styles.pb(3)}>
            <RowEntry
              label={voice.label}
              value={voice.value}
              labelVars={voice.labelVars}
              valueVars={voice.valueVars}
            />
          </View>
        ))}
      </View> */}
    </View>
  )
}

const BreakLine = () => {
  return (
    <View style={styles.pb(4)}>
      <View style={styles.line} />
    </View>
  )
}

const TermsAndConditions = () => {
  const [showTerms, setShowTerms] = useState(false)

  const theme = useTheme()

  const {
    data: { language }
  } = useContext(UnlimitedContext)

  const { height } = useWindowDimensions()

  const TERMS_URI = `https://api-web-ci-vfal.vodafone.com/file/UnlimitedHome/contract_${language}.pdf`

  return (
    <View style={[styles.tos, styles.pb(8)]}>
      <VFText
        style={[
          styles.label,
          styles.pb(8),
          styles.explainTxt,
          styles.term(theme)
        ]}
        i18nKey="unlimited_member_pay_explain"
      />
      <VFText
        i18nKey="unlimited_summary_tos_p1"
        style={[styles.label, styles.term(theme)]}
      />
      <TouchableOpacity onPress={() => setShowTerms(true)}>
        <VFText
          i18nKey="unlimited_summary_tos_p2"
          style={[styles.label, styles.term(theme), styles.underline]}
        />
      </TouchableOpacity>
      {Platform.OS === 'web' && Dimensions.get('window').width > 700 ?
        <ReactNativeModal
          isVisible={showTerms}
          backdropOpacity={0.5}
          onSwipeComplete={() => setShowTerms(false)}
          onBackdropPress={() => setShowTerms(false)}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              minWidth: '600px',
              maxWidth: '600px',
              height: 'auto',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              paddingTop: null,
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            <View
              style={{ height: height * 0.75 }}
              onStartShouldSetResponder={() => true}
            >
              <WebView
                startInLoadingState={true}
                source={{ uri: TERMS_URI }}
                renderLoading={() => {
                  return (
                    <View style={{ height: height * 0.75 }}>
                      <Loading />
                    </View>
                  )
                }}
              />
              <View style={styles.topSpace}>
                <VFButton
                  type="secondary"
                  title="unlimited_close"
                  style={styles.backButton}
                  onPress={() => setShowTerms(false)}
                />
              </View>
            </View>
          </View>
        </ReactNativeModal>
        :
        <QuickActionMenu
          type="secondary"
          isVisible={showTerms}
          headerStyle={styles.headerStyle}
          title="unlimited_terms_and_conditions"
          toggleModal={() => setShowTerms(false)}
        >
          <View
            style={{ height: height * 0.75 }}
            onStartShouldSetResponder={() => true}
          >
            <WebView
              startInLoadingState={true}
              source={{ uri: TERMS_URI }}
              renderLoading={() => {
                return (
                  <View style={{ height: height * 0.75 }}>
                    <Loading />
                  </View>
                )
              }}
            />
            <View style={styles.topSpace}>
              <VFButton
                type="secondary"
                title="unlimited_close"
                style={styles.backButton}
                onPress={() => setShowTerms(false)}
              />
            </View>
          </View>
        </QuickActionMenu>}
    </View>
  )
}

const ExplainButton = ({ offer }) => {
  const theme = useTheme()
  const UPFRONT_VALUE = (
    parseFloat(offer.price.value) + parseFloat(INSTALL.value)
  ).toString()

  const [showExplain, setShowExplain] = useState(false)
  const data = [
    {
      value: 'unlimited_summary_amount',
      label: 'unlimited_summary_monthly',
      valueVars: [(offer.price?.value ?? 0).toString()]
    },
    {
      value: 'unlimited_summary_amount',
      label: 'unlimited_summary_modem_deposit',
      valueVars: [MODEM.value]
    },
    {
      value: 'unlimited_summary_amount',
      label: 'unlimited_summary_installation_fee',
      valueVars: [INSTALL.value]
    }
  ]
  return (
    <>
      <TouchableOpacity onPress={() => setShowExplain(true)}>
        <VFText i18nKey="unlimited_summary_why" style={styles.whyBtn} />
      </TouchableOpacity>
      {Platform.OS === 'web' && Dimensions.get('window').width > 700 ?
        <ReactNativeModal
          isVisible={showExplain}
          backdropOpacity={0.5}
          onSwipeComplete={() => setShowExplain(false)}
          onBackdropPress={() => setShowExplain(false)}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              minWidth: '600px',
              maxWidth: '600px',
              height: 'auto',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              paddingTop: null,
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            <View>
              <VFText
                style={[styles.header, styles.weightNormal, styles.pb(4)]}
                placeHolders={[UPFRONT_VALUE]}
                i18nKey="unlimited_explain_dialog_title"
              />
              <VFText
                i18nKey="unlimited_explain_dialog_explanation"
                style={[styles.label, styles.pb(8), styles.lineHeight]}
              />
              <View style={styles.pb(4)}>
                {data.map(datum => (
                  <View style={styles.pb(2)}>
                    <RowEntry
                      label={datum.label}
                      value={datum.value}
                      valueVars={datum.valueVars}
                    />
                  </View>
                ))}
              </View>
              <BreakLine />
              <View style={styles.pb(15)}>
                <RowEntry
                  boldLabel
                  label="unlimited_total"
                  value="unlimited_summary_amount"
                  valueVars={[UPFRONT_VALUE]}
                />
              </View>
              <View style={styles.pb(4)}>
                <VFButton
                  title="unlimited_close"
                  onPress={() => setShowExplain(false)}
                />
              </View>
            </View>
          </View>
        </ReactNativeModal> :
        <QuickActionMenu
          type="secondary"
          isVisible={showExplain}
          titleStyle={styles.label}
          headerStyle={styles.headerStyle}
          title="unlimited_summary_cost_total"
          toggleModal={() => setShowExplain(false)}
        >
          <View>
            <VFText
              style={[styles.header, styles.weightNormal, styles.pb(4)]}
              placeHolders={[UPFRONT_VALUE]}
              i18nKey="unlimited_explain_dialog_title"
            />
            <VFText
              i18nKey="unlimited_explain_dialog_explanation"
              style={[styles.label, styles.pb(8), styles.lineHeight]}
            />
            <View style={styles.pb(4)}>
              {data.map(datum => (
                <View style={styles.pb(2)}>
                  <RowEntry
                    label={datum.label}
                    value={datum.value}
                    valueVars={datum.valueVars}
                  />
                </View>
              ))}
            </View>
            <BreakLine />
            <View style={styles.pb(15)}>
              <RowEntry
                boldLabel
                label="unlimited_total"
                value="unlimited_summary_amount"
                valueVars={[UPFRONT_VALUE]}
              />
            </View>
            <View style={styles.pb(4)}>
              <VFButton
                title="unlimited_close"
                onPress={() => setShowExplain(false)}
              />
            </View>
          </View>
        </QuickActionMenu>}

    </>
  )
}

const CheckoutSuccess = ({ show, onReset }) => {
  const theme = useTheme()
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <ReactNativeModal
        isVisible={show}
        backdropOpacity={0.5}
        onSwipeComplete={onReset}
        onBackdropPress={onReset}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            minWidth: '600px',
            maxWidth: '600px',
            height: 'auto',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            padding: '20px',
            paddingTop: null,
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          <View style={styles.body}>
            <View style={styles.main}>
              <Icon name={UhImages.red_tick} size={120} type="image" />
              <VFText
                style={styles.title}
                i18nKey="unlimited_order_success_title"
              />
              <VFText
                style={styles.descriptionText}
                i18nKey="unlimited_order_success_desc"
              />
            </View>
            <VFButton
              onPress={onReset}
              title="unlimited_close"
              style={styles.continueButton}
            />
          </View>
        </View>
      </ReactNativeModal>
    )
  }
  return (
    <QuickActionMenu
      type="secondary"
      isVisible={show}
      toggleModal={onReset}
      title="unlimited_order_success_modal"
      headerStyle={styles.bottomPadding}
    >
      <View style={styles.body}>
        <View style={styles.main}>
          <Icon name={UhImages.red_tick} size={120} type="image" />
          <VFText
            style={styles.title}
            i18nKey="unlimited_order_success_title"
          />
          <VFText
            style={styles.descriptionText}
            i18nKey="unlimited_order_success_desc"
          />
        </View>
        <VFButton
          onPress={onReset}
          title="unlimited_close"
          style={styles.continueButton}
        />
      </View>
    </QuickActionMenu>
  )
}

const CheckoutError = ({ show, error, onReset }) => {
  const theme = useTheme()
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <ReactNativeModal
        isVisible={show}
        backdropOpacity={0.5}
        onSwipeComplete={onReset}
        onBackdropPress={onReset}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            minWidth: '600px',
            maxWidth: '600px',
            height: 'auto',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            padding: '20px',
            paddingTop: null,
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          <View style={styles.body}>
            <View style={styles.main}>
              <Icon name={UhImages.error} size={120} type="image" />
              <VFText style={styles.title} i18nKey="%1$s" placeHolders={[error]} />
            </View>
            <VFButton
              onPress={onReset}
              title="unlimited_close"
              style={styles.continueButton}
            />
          </View>
        </View>
      </ReactNativeModal>
    )
  }
  return (
    <QuickActionMenu
      type="secondary"
      isVisible={show}
      toggleModal={onReset}
      title="unlimited_order_error_modal"
      headerStyle={styles.bottomPadding}
    >
      <View style={styles.body}>
        <View style={styles.main}>
          <Icon name={UhImages.error} size={120} type="image" />
          <VFText style={styles.title} i18nKey="%1$s" placeHolders={[error]} />
        </View>
        <VFButton
          onPress={onReset}
          title="unlimited_close"
          style={styles.continueButton}
        />
      </View>
    </QuickActionMenu>
  )
}

BreakdownHeader.propTypes = {
  onLayout: PropTypes.func
}

RowEntry.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  boldLabel: PropTypes.bool,
  valueVars: PropTypes.arrayOf(PropTypes.string),
  labelVars: PropTypes.arrayOf(PropTypes.string)
}

SelectedOfferSummary.propTypes = {
  offer: PropTypes.object,
  address: PropTypes.string
}

CostSection.propTypes = {
  offer: PropTypes.object,
  onCheckout: PropTypes.func,
  isCheckingOut: PropTypes.bool
}

Breakdown.propTypes = {
  offer: PropTypes.object
}

BreakdownContent.propTypes = {
  offer: PropTypes.object
}

ExplainButton.propTypes = {
  offer: PropTypes.object
}

SummaryStep.propTypes = {
  onCheckout: PropTypes.func,
  onClose: PropTypes.func
}

CheckoutSuccess.propTypes = {
  show: PropTypes.bool,
  onReset: PropTypes.func
}

CheckoutError.propTypes = {
  show: PropTypes.bool,
  error: PropTypes.string,
  onReset: PropTypes.func
}

export default SummaryStep
